import { defineMessages } from "react-intl";

const messages = defineMessages({
    title: {
        id: "article.rhytname.hello.title",
    },
    description: {
        id: "article.rhytname.hello.description",
    },
    simple: {
        id: "article.rhytladder.selection.simple",
    },
    combined: {
        id: "article.rhytladder.selection.combined",
    },
    custom: {
        id: "article.rhytladder.selection.custom",
    },
    simpleTitle: {
        id: "article.rhytladder.selection.simple.title",
    },
    combinedTitle: {
        id: "article.rhytladder.selection.combined.title",
    },
    customTitle: {
        id: "article.rhytladder.selection.custom.title",
    },
    ri: {
        id: "article.rhytname.ri",
    },
    ti: {
        id: "article.rhytname.ti",
    },
    tim: {
        id: "article.rhytname.tim",
    },
    ta: {
        id: "article.rhytname.ta",
    },
    tam: {
        id: "article.rhytname.tam",
    },
    taa: {
        id: "article.rhytname.taa",
    },
    taaa: {
        id: "article.rhytname.taaa",
    },
    taaaa: {
        id: "article.rhytname.taaaa",
    },
});

export default messages;
